import http from "../../http-common";
/* eslint-disable */
class AdvokasiService {
  advokasiList(page, itemPerPage, keyword) {
    return http.get(
      "/advokasi/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("no_telepon", data.no_telepon);
    bodyFormData.append("no_ktp", data.no_ktp);
    bodyFormData.append("pengaduan", data.pengaduan);

    if (data.selectedStatus && data.selectedStatus != undefined) {
      bodyFormData.append("status", data.selectedStatus.text);
    }

    return http.post("/advokasi", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("no_telepon", data.no_telepon);
    bodyFormData.append("no_ktp", data.no_ktp);
    bodyFormData.append("pengaduan", data.pengaduan);

    if (data.selectedStatus && data.selectedStatus != undefined) {
      bodyFormData.append("status", data.selectedStatus.text);
    }

    return http.put(`/advokasi/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/advokasi/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new AdvokasiService();
